export const paths = {
  dashboard: "/dashboard",
  portalDashboard: "/portal-dashboard",
  transaction: {
    list: "/transactions",
    create: "/transactions/create",
    edit: "/transactions/:id/edit",
  },
  master: {
    iku: {
      list: "/master/iku",
      create: "/master/iku/create",
      detail: "/master/iku/:id",
      edit: "/master/iku/:id/edit",
    },
    component: {
      list: "/master/component",
      create: "/master/component/create",
      edit: "/master/component/:id/edit",
      detail: "/master/component/:id",
    },
    formula: {
      list: "/master/formula",
      create: "/master/formula/create",
      edit: "/master/formula/:id/edit",
    },
    settingLock: "/master/period-lock",
  },
  master_data: {
    access_admin: {
      list: "/master-data/access-admin",
      create: "/master-data/access-admin/create",
      edit: "/master-data/access-admin/:id/edit",
    },
    facilities: {
      list: "/master-data/facilities",
      create: "/master-data/facilities/create",
      edit: "/master-data/facilities/:id/edit",
    },
    wedding_packages: {
      list: "/master-data/wedding-packages",
      create: "/master-data/wedding-packages/create",
      edit: "/master-data/wedding-packages/:id/edit",
    },
    vendors: {
      list: "/master-data/vendors",
      create: "/master-data/vendors/create",
      edit: "/master-data/vendors/:id/edit",
    },
    contacts: {
      list: "/master-data/contacts",
    },
  },
  content: {
    about_us: "/content/about-us",
    banner: "/content/banner",
    // event: "/content/event",
    // article: "/content/article",
    article: {
      list: "/content/article",
      create: "/content/article/create",
      edit: "/content/article/:id/edit",
    },
    event: {
      list: "/content/event",
      create: "/content/event/create",
      edit: "/content/event/:id/edit",
    },
    testimonial: {
      list: "/content/testimonial",
      create: "/content/testimonial/create",
      edit: "/content/testimonial/:id/edit",
    },
  },
  auth: {
    login: "/auth/login",
    loginProker: "/auth/login-proker",
    register: "/auth/register",
    callback: "/auth/oauth-callback",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
  },
  component: {
    list: "/component",
    ikp: "/component/ikp",
    iku: "/component/iku",
    realisasi: "/component/realisasi",
    realisasiDetail: "/component/realisasi/:type/:id",
    create: "/component/create",
    edit: "/component/:id/edit",
    detail: "/component/:id",
    view: "/component/view/:type/:id",
  },
  period: {
    list: "/period",
    create: "/period/create",
    edit: "/period/:id/edit",
    detail: "/period/:id",
  },
  user: {
    list: "/user",
    create: "/user/create",
    edit: "/user/:id/edit",
    detail: "/user/:id",
  },
  bidang: {
    list: "/bidang",
    create: "/bidang/create",
    edit: "/bidang/:id/edit",
    detail: "/bidang/:id",
  },
  pic: {
    list: "/pic",
  },
  unit: {
    list: "/unit",
    detail: "/unit/:id",
  },
  proker: {
    dashboard: "/proker/dashboard",
    unit: "/proker/unit",
    masterUnit: "/proker/master-unit",
    masterBudget: "/proker/master-budget",
    integrasi: "/proker/integrasi",
    output: "/proker/output",
    program: "/proker/program",
    aktivitas: "/proker/program/:id/aktivitas",
    indicatorDetail: "/proker/program/:id/indicator/:indicatorId",
    progress: "/proker/progress",
    evidence: "/proker/evidence",
    manajemenProgram: "/proker/manajemenProgram",
    approval: "/proker/approval",
    approvalAnggaran: "/proker/approvalAnggaran",
    manajemenApproval: "/proker/manajemenApproval",
    revision: "/proker/revision",
    rejected: "/proker/rejected",
    usulanAnggaranUser: "/proker/usulanAnggaranUser",
    guides: "/proker/guides",
  },
  verifikator: "/verifikator",
  guides: "/guides",
};
